import GraphicStandEditForm from './graphic-stand-edit-form';
import GraphicStandFilterForm from './graphic-stand-filter-form';

const GraphicStandForms = {
    Edit: GraphicStandEditForm,
    Filter: GraphicStandFilterForm
};

export default GraphicStandForms;